var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeWinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.217,
    height: 67.21,
    viewBox: "0 0 68.217 67.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy-svgrepo-com",
    transform: "translate(0 -3.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M170.444,73.542l11.4,41.047,11.4-41.047Z",
    transform: "translate(-147.735 -60.465)",
    fill: "#ddb200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44027",
    "data-name": "Group 44027",
    transform: "translate(34.101 13.077)",
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M255.941,73.542v41.047l11.4-41.047Z",
    transform: "translate(-255.941 -73.542)",
    fill: "#663c1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44028",
    "data-name": "Group 44028",
    transform: "translate(5.73 31.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M43.008,228.132l28.379,8.428-10.393-22.3Z",
    transform: "translate(-43.008 -214.262)",
    fill: "#ddb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M284.382,228.132,256,236.56l10.393-22.3Z",
    transform: "translate(-227.624 -214.262)",
    fill: "#ddb200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M181.844,29.612l7.045,3.452L187.783,25.3l5.46-5.634-7.729-1.348-3.67-6.934-3.671,6.934-7.729,1.348L175.9,25.3,174.8,33.064Z",
    transform: "translate(-147.735 -6.587)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44029",
    "data-name": "Group 44029",
    transform: "translate(5.73 40.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M285.366,285.422l-6.566-5.063-21.417,13.374Z",
    transform: "translate(-228.821 -280.108)",
    fill: "#663c1d",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M43.008,283.791l6.366-5.314L70.691,292.1Z",
    transform: "translate(-43.008 -278.477)",
    fill: "#663c1d",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2592",
    "data-name": "Rectangle 2592",
    width: 20.004,
    height: 11.476,
    transform: "translate(18.376 13.624)",
    fill: "#663c1d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2593",
    "data-name": "Rectangle 2593",
    width: 38.899,
    height: 7.821,
    transform: "translate(8.926 21.778)",
    fill: "#663c1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44030",
    "data-name": "Group 44030",
    transform: "translate(1.013 23.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    d: "M349.052,161.806l7.658,1.563-5.6,5.454.88,7.766-6.917-3.638-7.114,3.237,1.323-7.7-5.277-5.765,7.735-1.123,3.853-6.8Z",
    transform: "translate(-290.518 -154.797)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M15.259,161.806,7.6,163.369l5.6,5.454-.88,7.766,6.917-3.638,7.114,3.237-1.323-7.7L30.3,162.72,22.569,161.6l-3.853-6.8Z",
    transform: "translate(-7.601 -154.797)",
    fill: "#eebf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44031",
    "data-name": "Group 44031",
    transform: "translate(14.657 54.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2594",
    "data-name": "Rectangle 2594",
    width: 4.31,
    height: 8.152,
    transform: "translate(25.144)",
    fill: "#56361d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2595",
    "data-name": "Rectangle 2595",
    width: 4.31,
    height: 7.821,
    transform: "translate(34.588 8.154)",
    fill: "#56361d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2596",
    "data-name": "Rectangle 2596",
    width: 36.002,
    height: 3.501,
    transform: "translate(0 12.473)",
    fill: "#56361d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44032",
    "data-name": "Group 44032",
    transform: "translate(5.73 9.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8490",
    "data-name": "Path 8490",
    d: "M374.777,198.024l-.755-1.53-9.18,9.18-1.156,6.732,4.906-2.232,11.139-11.139Z",
    transform: "translate(-320.96 -176.819)",
    fill: "#ffeb99",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8491",
    "data-name": "Path 8491",
    d: "M214.713,50.768l-1.03-1.946-8.751,8.751.171.177L204,65.517l3.612-1.77L219.715,51.64Z",
    transform: "translate(-182.547 -48.822)",
    fill: "#ffeb99",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8492",
    "data-name": "Path 8492",
    d: "M53.259,201.781l-.353-.624-9.167,9.167-.731,6.449,4.927-2.592,11.5-11.5Z",
    transform: "translate(-43.008 -180.86)",
    fill: "#ffeb99",
    opacity: 0.38
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8493",
    "data-name": "Path 8493",
    d: "M68.177,32.189a1.012,1.012,0,0,0-.769-.707l-7.172-1.463L57,23.455a1.013,1.013,0,0,0-1.789-.051L51.6,29.772l-7.244,1.051h0a1.013,1.013,0,0,0-.125.027l-.025.008q-.049.015-.1.035l-.025.01a1.018,1.018,0,0,0-.11.058l-.009.006a1.019,1.019,0,0,0-.093.066l-.02.017a.989.989,0,0,0-.084.078l-.007.007a1,1,0,0,0-.08.1l-.015.022c-.018.027-.035.055-.051.084l-.018.033-.013.025L38.356,42.616l8.128-29.268c0-.009,0-.017.006-.026s.006-.025.008-.037c.007-.031.012-.063.015-.094,0-.009,0-.019,0-.028a1.017,1.017,0,0,0,0-.126V13.03a1.026,1.026,0,0,0-.013-.117l0-.027a1,1,0,0,0-.029-.114l0-.007v0a.969.969,0,0,0-.047-.116l-.014-.028a.946.946,0,0,0-.049-.085l-.015-.024a1.017,1.017,0,0,0-.074-.1l-.013-.014a.968.968,0,0,0-.075-.075l-.021-.019a1.04,1.04,0,0,0-.094-.072l0,0a1,1,0,0,0-.109-.062l-.027-.012q-.043-.019-.088-.035L45.8,12.11,45.78,12.1c-.03-.009-.061-.015-.091-.021h-.012l-7.234-1.262L35,4.321a1.012,1.012,0,0,0-1.789,0l-3.439,6.5-7.235,1.262h-.012c-.03.006-.061.012-.091.02l-.023.008-.036.012c-.03.01-.06.022-.089.035l-.027.012a1.01,1.01,0,0,0-.11.062l0,0a1.024,1.024,0,0,0-.095.072l-.021.019a.992.992,0,0,0-.075.075l-.013.014a1.019,1.019,0,0,0-.074.1l-.015.024c-.018.028-.034.056-.049.085l-.014.028a1.051,1.051,0,0,0-.047.116v0l0,.007a1,1,0,0,0-.029.114l0,.027a1.007,1.007,0,0,0-.013.117s0,0,0,.007a1.022,1.022,0,0,0,0,.126c0,.009,0,.018,0,.027,0,.032.009.063.015.095,0,.012.005.024.008.036s0,.018.006.027l8.128,29.268L24.634,31.4l-.013-.024-.019-.035c-.015-.028-.032-.055-.05-.081l-.016-.024a1,1,0,0,0-.079-.1l-.01-.01a.975.975,0,0,0-.08-.075l-.023-.019a1,1,0,0,0-.089-.063l-.013-.009a1.033,1.033,0,0,0-.108-.057l-.028-.012c-.03-.013-.061-.024-.093-.034l-.028-.009a1.017,1.017,0,0,0-.123-.027h0l-7.244-1.051L13.009,23.4a1.013,1.013,0,0,0-1.789.051L7.982,30.019.81,31.482a1.012,1.012,0,0,0-.5,1.717l5.243,5.108-.825,7.273s0,.006,0,.009a1.007,1.007,0,0,0-.006.128s0,.007,0,.01a.954.954,0,0,0,.011.114c0,.009,0,.019,0,.028a1,1,0,0,0,.025.109l0,.013a1.029,1.029,0,0,0,.043.114l.013.027c.014.029.029.057.046.084l.016.027a1,1,0,0,0,.072.1l.009.01a.972.972,0,0,0,.078.081l.021.019a1,1,0,0,0,.093.074l0,0h0a1,1,0,0,0,.12.069l.028.013a1,1,0,0,0,.114.044l.016.006,0,0,22.3,6.623H24.106A1.012,1.012,0,0,0,23.094,54.3v6.845H14.657a1.012,1.012,0,0,0-1.012,1.012v7.821a1.012,1.012,0,0,0,1.012,1.012h38.9a1.012,1.012,0,0,0,1.012-1.012V62.158a1.012,1.012,0,0,0-1.012-1.012H45.123V54.3a1.012,1.012,0,0,0-1.012-1.012H40.477l22.3-6.623,0,0,.015-.005a1.045,1.045,0,0,0,.115-.045l.027-.013a1,1,0,0,0,.121-.07h0l0,0a1.043,1.043,0,0,0,.094-.074l.021-.019a1,1,0,0,0,.078-.081l.009-.009a1,1,0,0,0,.072-.1l.016-.027c.017-.027.032-.055.045-.084l.013-.028a1.007,1.007,0,0,0,.043-.114l0-.013a.972.972,0,0,0,.025-.108c0-.01,0-.019,0-.029a.977.977,0,0,0,.011-.114s0-.007,0-.011a1.007,1.007,0,0,0-.006-.128s0-.006,0-.009l-.824-7.273L67.911,33.2A1.013,1.013,0,0,0,68.177,32.189ZM52.544,68.967H15.67v-5.8H52.544v5.8Zm-29.1-35.339,8.4,18.011L20.683,44.676l-1.162-6.767Zm-4.157,12.56,7.56,4.721L8.4,45.433l4.276-2.249Zm5.467-29.553L27.1,19.059l-.568,3.989ZM40.51,27.289l-5.389,19.4V24.649Zm.61-8.231,2.349-2.424-1.781,6.413ZM33.1,46.694l-5.389-19.4L33.1,24.649Zm15.84-.506,6.6-3,4.276,2.249L41.376,50.909Zm-1.4-1.512L36.384,51.639l8.4-18.011L48.7,37.908ZM30.612,12.726a1.012,1.012,0,0,0,.721-.524l2.776-5.244L36.885,12.2a1.013,1.013,0,0,0,.721.524l5.845,1.02-4.129,4.26a1.013,1.013,0,0,0-.275.847l.836,5.874-5.328-2.611-.017-.007c-.023-.011-.048-.021-.072-.03l-.032-.012c-.024-.008-.049-.015-.075-.022l-.032-.008c-.026-.006-.052-.01-.078-.013l-.031,0c-.031,0-.062,0-.093-.005h-.032c-.031,0-.062,0-.093.005l-.032,0c-.026,0-.052.008-.077.013l-.033.009c-.025.006-.049.013-.073.021l-.033.012q-.036.014-.071.03l-.018.008-5.328,2.611.836-5.874a1.013,1.013,0,0,0-.275-.847l-4.129-4.26ZM3.089,33.084,8.873,31.9a1.013,1.013,0,0,0,.706-.544l2.612-5.294L15.1,31.2a1.012,1.012,0,0,0,.735.5l5.842.848-3.986,4.355a1.012,1.012,0,0,0-.251.855l1,5.818-5.373-2.445a1.012,1.012,0,0,0-.891.025L6.952,43.909l.665-5.866a1.013,1.013,0,0,0-.3-.839ZM43.1,61.109H25.119v-5.8H43.1v5.8ZM60.9,37.2a1.013,1.013,0,0,0-.3.839l.665,5.866-5.225-2.748a1.012,1.012,0,0,0-.891-.025L49.778,43.58l1-5.818a1.012,1.012,0,0,0-.251-.855L46.54,32.553l5.842-.848a1.012,1.012,0,0,0,.735-.5l2.91-5.136,2.612,5.294a1.013,1.013,0,0,0,.706.544l5.784,1.18Z",
    transform: "translate(0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeWinner);
export default __webpack_public_path__ + "static/media/beWinner.6aa277dc5bc9ec9e4e5e7575f6c0a854.svg";
export { ForwardRef as ReactComponent };